import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { UtilisateurService } from './utilisateur.service';
import { GroupeFormationModel } from 'src/models/groupe-formation/groupe-formation-model';
import { Observable } from 'rxjs';
import { UtilisateurFormationModel } from 'src/models/groupe-formation/utilisateur-formation-model';

@Injectable({
  providedIn: 'root'
})
export class GroupeFormationService {

private baseUrl = environment.api_LMS + 'GroupeFormation';

  constructor(private http: HttpClient, private translateService: TranslateService, private utilisateurService: UtilisateurService) { }

  ObtenirGroupeFormations(): Observable<GroupeFormationModel[]> {
    const utilisateurId = this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId;
    const entiteId = this.utilisateurService.entiteUtilisateurSelectionnee.entiteId;
    const params = {
      entiteId: entiteId.toString(),
      utilisateurId: utilisateurId.toString()
    };

    return this.http.get<GroupeFormationModel[]>(`${this.baseUrl}/ObtenirGroupeFormations`, { params });
  }


  ObtenirUtilisateursEntite(): Observable<UtilisateurFormationModel[]> {
    return this.http.get<UtilisateurFormationModel[]>(`${this.baseUrl}/ObtenirUtilisateurEntite`, { params: { entiteId: this.utilisateurService.entiteUtilisateurSelectionnee.entiteId, utilisateurId: this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId } });
  }

  CreerFormationGroupe(GroupeFormationModel: GroupeFormationModel ): Observable<GroupeFormationModel> {
     GroupeFormationModel.ajouterParUtilisateurId = this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId;
     GroupeFormationModel.entiteId = this.utilisateurService.entiteUtilisateurSelectionnee.entiteId;
     GroupeFormationModel = this.ajusterAjouterFormationGroupeUtilisateurs(GroupeFormationModel);
    return this.http.post<GroupeFormationModel>(`${this.baseUrl}/CreerFormationGroupe`, GroupeFormationModel);
  }

  ModifierFormationGroupe(formationId: number, GroupeFormationModel: GroupeFormationModel ): Observable<GroupeFormationModel> {
    return this.http.put<GroupeFormationModel>(`${this.baseUrl}/ModifierFormationGroupe`, GroupeFormationModel, { params: { formationId: formationId , utilisateurId: this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId} });
  }

  EnregistrerPresenceFormationGroupe(formationId: number, GroupeFormationModel: GroupeFormationModel): Observable<GroupeFormationModel> {
    return this.http.put<GroupeFormationModel>(`${this.baseUrl}/EnregistrerPresenceFormationGroupe`, GroupeFormationModel, { params: { formationId: formationId } });
  }


  SupprimerFormationGroupe(formationId: number): Observable<any> {
    return this.http.put<GroupeFormationModel>(`${this.baseUrl}/RetirerFormationGroupe`, null, { params: { formationId: formationId, utilisateurRetraitId: this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId } });
  }

  exporterFormations(formationIds: number[], codeLangue: string): Observable<Blob> {
    return this.http.post(`${this.baseUrl}/Exporter`, formationIds, {
      responseType: 'blob',
      params: { codeLangue }
    });
  }

  exporterFormationsPdf(formationIds: number[], codeLangue: string): Observable<Blob> {
    return this.http.post(`${this.baseUrl}/ExporterPdf`, formationIds, {
      responseType: 'blob',
      params: { codeLangue }
    });
  }

  private ajusterAjouterFormationGroupeUtilisateurs(formationGroupe: GroupeFormationModel): GroupeFormationModel {
   formationGroupe.utilisateurs.forEach(element => {
     element.ajouteParUtilisateurId = this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId;
   });
    return formationGroupe;
  }
}
